import { Button, Modal, Tabs } from 'antd';
import React from 'react';
import s from './s.module.less';
import commonS from 'styles/common.module.less';
import PrescriptionsLandingPage from '../PrescriptionsLandingPage';
import PrescriptionsPatientTable from './components/PrescriptionsPatientTable';
import SelectPatientModal from './components/SelectPatientModal';
import AddPrescribeMedicationModal from './components/AddPrescribeMedicationModal';
import { Prospect } from 'types/common';
import PrescriptionsLogTable from './components/PrescriptionsLogTable';
import PrescriptionsReportsTable from './components/PrescriptionsReportsTable';
import useCurrentUser from 'hooks/useCurrentUser';
import { canShowGroupPracticeView } from 'utils/common';
import { EViewType } from 'types/group';

const PrescriptionsDashboradPage = () => {
    const [showLearnMore, setShowLearnMore] = React.useState<boolean>(false);
    const [showSelectPatientModal, setShowSelectPatientModal] = React.useState<boolean>(false);
    const [showPrescribeMedicationModal, setShowPrescribeMedicationModal] = React.useState<boolean>(false);
    const [currentTab, setCurrentTab] = React.useState<string>('1');
    const [targetProspect, setTargetProspect] = React.useState<Prospect | undefined>(undefined);

    const [currentUser] = useCurrentUser();
    const showGroupPracticeView = canShowGroupPracticeView(currentUser);
    const [activeTab, setActiveTab] = React.useState<'practice' | 'my'>('practice');

    return (
        <div className={s.wrap}>
            <div className={s.header}>
                <span>Prescriptions</span>
                <div className={s.btnWrap}>
                    <Button
                        onClick={() => {
                            setShowLearnMore(true);
                        }}
                        className={s.btn}
                        size="large"
                    >
                        Learn more
                    </Button>
                    {(activeTab === 'my' || !showGroupPracticeView) && (
                        <Button
                            type="primary"
                            onClick={() => {
                                setShowSelectPatientModal(true);
                            }}
                            className={s.btn2}
                            size="large"
                        >
                            Prescribe new drug
                        </Button>
                    )}
                </div>
            </div>
            <div className={s.des}>
                Send prescriptions seamlessly with Klarity E-Prescriptions powered by ScriptSure.
            </div>
            {showGroupPracticeView && (
                <div className={s.viewTabs}>
                    <Tabs
                        activeKey={activeTab}
                        onChange={(key) => setActiveTab(key as 'practice' | 'my')}
                        items={[
                            { key: 'practice', label: 'Practice view' },
                            { key: 'my', label: 'My prescriptions' },
                        ]}
                    />
                </div>
            )}
            {(!showGroupPracticeView || activeTab === 'my') && (
                <div className={s.tabWrap}>
                    <Tabs
                        defaultActiveKey="1"
                        onChange={(key) => {
                            setCurrentTab(key as '1' | '2');
                        }}
                    >
                        <Tabs.TabPane tab="Activity Overview" key="1">
                            <div className={s.tableWrap}>
                                <PrescriptionsPatientTable
                                    viewType={EViewType.PROVIDER_SELF}
                                    providerId={currentUser?.provider?.id}
                                />
                            </div>
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="Activity Log" key="2">
                            <div className={s.tableWrap}>
                                <PrescriptionsLogTable />
                            </div>
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="Reports" key="3">
                            <div className={s.tableWrap}>
                                <PrescriptionsReportsTable />
                            </div>
                        </Tabs.TabPane>
                    </Tabs>
                </div>
            )}
            {showGroupPracticeView && activeTab === 'practice' && (
                <div className={s.tableWrap}>
                    <PrescriptionsPatientTable viewType={EViewType.GROUP_PRACTICE} showProviderColumn />
                </div>
            )}

            <Modal
                open={showLearnMore}
                onCancel={() => {
                    setShowLearnMore(false);
                }}
                footer={null}
                width="84%"
                className={commonS.modalFixHeightWithoutPaddingWrap}
                title="Learn more about Klarity E-Prescriptions"
            >
                <PrescriptionsLandingPage isModal />
            </Modal>
            <SelectPatientModal
                open={showSelectPatientModal}
                onClose={() => setShowSelectPatientModal(false)}
                onSelected={(prospect) => {
                    setShowSelectPatientModal(false);
                    setTargetProspect(prospect);
                    setShowPrescribeMedicationModal(true);
                }}
            />
            <AddPrescribeMedicationModal
                prospectId={targetProspect?.id}
                open={showPrescribeMedicationModal}
                onClose={() => {
                    setTargetProspect(undefined);
                    setShowPrescribeMedicationModal(false);
                }}
            />
        </div>
    );
};

export default PrescriptionsDashboradPage;
